import { toast } from "sonner";
import { ETIQUETAS_PADRAO } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { codigoDoPedido } from "@/lib/codigo-do-pedido";
import type { IncomingOrderRow } from "./production-types";
import { abrirImpressao } from "./impressao";
import { POPUP, paginaUnicaDoPedido } from "./etiqueta-do-pedido";
import { useLinkDoCatalogo } from "@/components/catalogo/publico/use-link-do-catalogo";

const nada = { imprimir: () => {}, cancelar: () => {} };

/**
 * Aceitar o pedido já imprime as etiquetas únicas (uma por serviço), se o laboratório deixou ligado
 * em Configurações › Etiquetas. A janela abre na hora do clique em "Aceitar" — depois do `await` do
 * servidor o navegador bloquearia como pop-up — e só recebe as etiquetas quando o aceite confirma.
 */
export function useEtiquetasAoAceitar() {
  const config = trpc.organization.etiquetas.useQuery().data ?? ETIQUETAS_PADRAO;
  const lab = trpc.organization.getProfiles.useQuery().data;
  const logo = lab?.labProfile?.logoUrl ?? lab?.logoUrl ?? null;
  const urlDoCatalogo = useLinkDoCatalogo();

  return (order: IncomingOrderRow) => {
    if (!config.unica.imprimirAoAceitar) return nada;
    const janela = abrirImpressao(460, 640);
    if (!janela) {
      toast.error(POPUP);
      return nada;
    }
    return {
      imprimir: () => {
        const pagina = paginaUnicaDoPedido(config.unica, order, logo, undefined, urlDoCatalogo);
        janela.escrever(`Etiquetas — pedido ${codigoDoPedido(order)}`, pagina.css, pagina.corpo);
      },
      cancelar: () => janela.fechar(),
    };
  };
}
